import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  FaUserCircle,
  FaGlobe,
  FaUser,
  FaUserEdit,
  FaSignOutAlt,
} from "react-icons/fa";

export default function Header() {
  const [showUser, setShowUser] = useState(false);
  const [showLang, setShowLang] = useState(false);
  const navigate = useNavigate();

  const logout = () => {
    localStorage.clear();
    setShowUser(false);
    navigate("/");
  }

  return (
    <nav className="h-[66px] bg-[#1e2a44] text-white flex items-center">
      <div className="w-full flex items-center px-4">

        {/* BRAND */}
        <Link
          to="/dashboard"
          className="text-[24px] font-semibold mr-4 whitespace-nowrap ml-12"
        >
          Belize Offshore
        </Link>

        {/* RIGHT AREA */}
        <ul className="navbar-nav ml-auto flex items-center gap-6 pr-6">

          {/* LANGUAGE */}
          <li className="relative nav-item">
            <button
              type="button"
              onClick={() => {
                setShowLang(!showLang);
                setShowUser(false);
              }}
              className="nav-link flex items-center gap-2 text-white"
            >
              <FaGlobe size={20} />
              <span className="text-lg">English</span>
            </button>
          </li>

          {/* USER DROPDOWN */}
          <li className="relative">
            <button
              onClick={() => {
                setShowUser(!showUser);
                setShowLang(false);
              }}
              className="flex items-center text-white"
            >
              <FaUserCircle size={24} />
            </button>

            <div
              className={`
                absolute right-0 top-full z-50
                w-56 bg-white text-gray-800
                rounded-md shadow-lg
                transition-all duration-200
                ${showUser ? "opacity-100 visible mt-2" : "opacity-0 invisible mt-0"}
              `}
            >
              <Link
                to="/profile"
                onClick={() => setShowUser(false)}
                className="flex items-center gap-2 px-4 py-2 hover:bg-gray-100"
              >
                <FaUser />
                Profile Overview
              </Link>

              <Link
                to="/settings"
                onClick={() => setShowUser(false)}
                className="flex items-center gap-2 px-4 py-2 hover:bg-gray-100"
              >
                <FaUserEdit />
                Profile Settings
              </Link>

              <div className="my-1 h-px bg-gray-200"></div>

              <button
                onClick={logout}
                className="w-full text-left flex items-center gap-2 px-4 py-2 text-red-600 hover:bg-gray-100"
              >
                <FaSignOutAlt />
                Logout
              </button>
            </div>
          </li>
        </ul>
      </div>
    </nav>
  );
}

